<template>
  <div class="questionnaire-page">
    <div class="header">
      <div class="title">{{ detailObj && detailObj.title }}</div>
      <div class="desc">{{ detailObj && detailObj.description }}</div>
    </div>
    <div class="question-box">
      <div v-for="(question, index) in detailObj.questions" :key="question.id" class="question">
        <div class="title">
          <span>{{ index + 1 }}. </span>
          <span class="title-txt">{{ question && question.title }}</span>
          <span class="required" v-if="question && question.required">*</span>
        </div>
        <div class="question-cont" v-if="question.type === 'single'">
          <van-field
            :value="getName(question.answer, question.options)"
            is-link
            readonly
            @click="showPicker(index)"
            :placeholder="question.placeholder || '请选择'"
          />
          <van-popup v-model="question.showPopup" position="bottom"
                     :ref="`popup_${question.id}`"
          >
            <van-picker
              :ref="`picker_${question.id}`"
              show-toolbar
              :columns="question && question.options"
              value-key="value"
              @confirm="onConfirm($event, question)"
              @cancel="question.showPopup = false"
            >
              <template #option="option">
                <span>{{ option && option.text }}</span>
              </template>
            </van-picker>
          </van-popup>
          <van-field
            v-if="getName(question.answer, question.options) === '其他'"
            v-model="question.textValue"
            :placeholder="'请输入'"
            @input="answerChange(question)"
          />
          <div v-if="question.errorText" class="error-message">
            请输入其他内容
          </div>
          <div v-if="question.error" class="error-message">
            请回答此题
          </div>
        </div>
        <div class="question-cont" v-else-if="question.type === 'multiple'">
          <van-checkbox-group v-model="question.answers" @change="handleMultipleChange($event, index)">
            <div v-for="(option, idx) in question.options" :key="option.id" class="option-container">
              <van-checkbox
                shape="square"
                checked-color="#EB1700"
                :name="option.id"
              >
                {{ option && option.text }}
              </van-checkbox>
              <div v-if="option.hasSubOptions && question.answers.includes(option.id)">
                <van-field
                  :value="getName(option.subAnswer, option.subOptions)"
                  is-link
                  readonly
                  @click="showSubPicker(index, idx)"
                  :placeholder="question.placeholder || '请选择'"
                />
                <van-popup v-model="option.showSubPopup" position="bottom"
                           :ref="`subPopup_${question.id}_${option.id}`">
                  <van-picker
                    :ref="`subPicker_${question.id}_${option.id}`"
                    show-toolbar
                    :columns="option.subOptions"
                    @confirm="onSubConfirm($event, index, idx)"
                    @cancel="option.showSubPopup = false"
                  />
                </van-popup>
                <div v-if="option.error" class="error-message">
                  请选择子选项
                </div>
              </div>
              <van-field
                v-if="question.answers.includes(option.id) && option.text === '其他'"
                v-model="option.textValue"
                :placeholder="'请填写其他内容'"
                @input="answerOptionChange(option)"
              />
              <div v-if="option.errorText" class="error-message">
                请填写其他内容
              </div>
            </div>
          </van-checkbox-group>
          <div v-if="question.error" class="error-message">
            请回答此问题
          </div>
        </div>
        <div class="question-cont" v-else-if="question.type === 'input'">
          <van-field v-model="question.answer" @input="answerChange(question)" placeholder="请输入答案"/>
          <div v-if="question.error" class="error-message">
            请回答此题
          </div>
        </div>
        <div class="question-cont" v-else-if="question.type === 'rate'">
          <van-rate v-model="question.answer" @change="answerChange(question)" :count="question.maximumScore || 5"/>
          <div v-if="question.error" class="error-message">
            请回答此题
          </div>
        </div>
      </div>
      <div class="warp-btn">
        <div class="submit-btn btn1" @click.stop="$router.back()" v-track="{functionName: '问卷取消'}">取消</div>
        <div class="submit-btn btn2" @click.stop="submit(1)" v-track="{functionName: '问卷提交'}">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import {getQuestionDetail, getSurveyShowUserId, getSurveySubmissionApi, surveySubmission} from '../../api/questionnaire'
import {Dialog, Toast} from 'vant'
import withRouteTracking from '../../utils/withRouteTracking'
import {getShareInfo} from '../../utils/wxShare'

const profile = {
  data() {
    return {
      showSubPopup: {},
      detailObj: {},
      submitId: '',
      surveyId: '',
      answers: [],
      loading: false,
      isSubmitSuccess: false,
      isNoPermission: false
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    getName() {
      return (answer, options) => {
        if (!answer) {
          return ''
        }
        if (!Array.isArray(options)) {
          return ''
        }
        return options.find(item => item.id === answer).text
      }
    },
  },
  async created() {
    if (this.$route.query.submitId) {
      this.submitId = this.$route.query.submitId
    }
    if (this.$route.query.surveyId) {
      this.surveyId = this.$route.query.surveyId
    }
    if (this.surveyId) {
      await this.getDetail(this.surveyId)
      window.sessionStorage.setItem('mainId', this.surveyId)
      window.sessionStorage.setItem('serviceId', this.surveyId)
      let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : window.sessionStorage.getItem('entrance')
      window.sessionStorage.setItem('entrance', entrance)
      getShareInfo({
        title: this.detailObj.title,
        titleTimeLine: this.detailObj.title,
        desc: '问卷调查',
        link: window.location.href,
        linkTimeLine: window.location.href,
        images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
      })
    }
    await this.getSurveyShowUserId()
    if (this.submitId) {
      await this.getSurveySubmission(this.submitId)
    }
    if (this.answers.length) {
      this.handleAnswers()
    }
  },
  methods: {
    async getSurveyShowUserId() {
      try {
        const res = await getSurveyShowUserId(this.userInfo.id)

        // 提前返回，减少嵌套
        if (res.code !== 0) {
          this.handleNoPermission()
          return
        }

        const data = res.data

        if (!data.length) {
          this.handleNoPermission()
          return
        }

        const matchedItem = data.find(item => item.surveyId === this.surveyId)
        if (matchedItem) {
          this.submitId = matchedItem.submitId
        } else {
          this.handleNoPermission()
          return
        }
      } catch (e) {
        // 增强异常处理
        console.error('获取问卷信息失败:', e)
        Toast('系统异常，请稍后重试')
        this.$router.replace('/home')
      }
    },

    // 提取重复逻辑
    handleNoPermission() {
      this.isNoPermission = true
      Toast('该问卷无权限')
      this.$router.replace('/home')
    },
    handleAnswers() {
      // 边界条件检查
      if (!Array.isArray(this.detailObj.questions) || this.detailObj.questions.length === 0 || !Array.isArray(this.answers)) {
        return
      }
      // 提前分组 answers，减少重复过滤
      const answerMap = {}
      this.answers.forEach(answer => {
        if (!answerMap[answer.questionId]) {
          answerMap[answer.questionId] = []
        }
        answerMap[answer.questionId].push(answer)
      })
      this.detailObj.questions.forEach(question => {
        const answersForQuestion = answerMap[question.id] || []
        switch (question.type) {
          case 'single':
            const singleAnswer = answersForQuestion.find(answer => answer.answerType === 1)
            if (singleAnswer) {
              this.$set(question, 'answer', singleAnswer.optionId)
              this.$set(question, 'textValue', singleAnswer.textValue)
            }
            break
          case 'multiple':
            const multipleAnswers = answersForQuestion.filter(answer => answer.answerType === 1)
            if (multipleAnswers.length) {
              const answers = []
              multipleAnswers.forEach(answer => {
                answers.push(answer.optionId)
                if (question.options) { // 确保 options 存在
                  question.options.forEach(option => {
                    if (option.id === answer.optionId) {
                      if (option.text === '其他') {
                        this.$set(option, 'textValue', answer.textValue)
                      }
                      if (option.hasSubOptions) {
                        this.$set(option, 'subAnswer', answer.subOptionId)
                      }
                    }
                  })
                }
              })
              this.$set(question, 'answers', answers)
            }
            break
          case 'input':
            const inputAnswer = answersForQuestion.find(answer => answer.answerType === 2)
            if (inputAnswer) {
              this.$set(question, 'answer', inputAnswer.textValue)
            }
            break
          case 'rate':
            const rateAnswer = answersForQuestion.find(answer => answer.answerType === 3)
            if (rateAnswer) {
              this.$set(question, 'answer', rateAnswer.rateValue)
            }
            break
        }
      })
    },
    async getSurveySubmission(submitId) {
      try {
        const {code, data, msg} = await getSurveySubmissionApi(submitId)
        if (code === 0) {
          this.answers = data
        } else {
          Toast(msg)
        }
      } catch (e) {
        throw e
      }
    },
    async getDetail(surveyId) {
      try {
        const {code, data, msg} = await getQuestionDetail(surveyId)
        if (code === 0) {
          this.detailObj = data
          this.detailObj.questions.forEach(question => {
            switch (question.type) {
              case 'single':
                this.$set(question, 'answer', '')
                this.$set(question, 'textValue', '')
                break
              case 'multiple':
                this.$set(question, 'answers', [])
                question.options.forEach(option => {
                  if (option.hasSubOptions) {
                    this.$set(option, 'subAnswer', '')
                  }
                  if (option.text === '其他') {
                    this.$set(option, 'textValue', '')
                  }
                })
                break
              case 'input':
                this.$set(question, 'answer', '')
                break
              case 'rate':
                this.$set(question, 'answer', 0)
                break
            }
          })
        } else {
          Toast(msg)
          this.isNoPermission = true
          this.$router.replace('/home')
        }
      } catch (e) {
        throw e
      }
    },
    showPicker(index) {
      this.$set(this.detailObj.questions[index], 'showPopup', true)
    },
    answerOptionChange(option) {
      if (option.textValue) {
        delete option.errorText
      } else {
        this.$set(option, 'errorText', true)
      }
    },
    answerChange(question) {
      if (!question.answer && question.required) {
        this.$set(question, 'error', true)
      } else {
        delete question.error
      }
      if (question.type === 'single') {
        if (question.textValue) {
          delete question.errorText
        } else {
          this.$set(question, 'errorText', true)
        }
      }
    },
    onConfirm(value, question) {
      if (value.text === '其他') {
        this.$set(question, 'textValue', '')
        this.$set(question, 'errorText', true)
      }
      this.$set(question, 'answer', value.id)
      this.$set(question, 'error', false)
      this.$set(question, 'showPopup', false)
    },
    showSubPicker(index, optionIndex) {
      this.$set(this.detailObj.questions[index].options[optionIndex], 'showSubPopup', true)
    },
    onSubConfirm(value, index, optionIndex) {
      this.$set(this.detailObj.questions[index].options[optionIndex], 'showSubPopup', false)
      this.$set(this.detailObj.questions[index].options[optionIndex], 'subAnswer', value.id)
      if (this.detailObj.questions[index].options[optionIndex].hasSubOptions && !value) {
        this.$set(this.detailObj.questions[index].options[optionIndex], 'error', true)
      } else {
        delete this.detailObj.questions[index].options[optionIndex].error
      }
    },
    handleMultipleChange(value, index) {
      if (!value.length && this.detailObj.questions[index].required) {
        this.$set(this.detailObj.questions[index], 'error', true)
      } else {
        delete this.detailObj.questions[index].error
      }
      if (value.length) {
        this.detailObj.questions[index].options.forEach(option => {
          if (option.hasSubOptions && !option.subAnswer) {
            this.$set(option, 'error', true)
          } else {
            delete option.error
          }
          if (option.text === '其他' && !option.textValue) {
            this.$set(option, 'errorText', true)
          } else {
            delete option.errorText
          }
          if (option.hasSubOptions && !value.includes(option.id)) {
            this.$set(option, 'subAnswer', '')
            delete option.error
          }
          if (option.text === '其他' && !value.includes(option.id)) {
            this.$set(option, 'textValue', '')
            delete option.errorText
          }
        })
      }
    },
    async submit(submitStatus) {
      if (this.loading) return
      this.isSubmitSuccess = false
      if (submitStatus === 1) {
        if (!this.validate()) {
          return
        }
      }
      let params = {
        'surveyId': this.surveyId,
        'id': this.submitId,
        'userId': this.userInfo.id,
        'submitStatus': submitStatus,
        'answers': []
      }
      this.detailObj.questions.forEach(question => {
        if (question.type === 'single') {
          if (question.answer) {
            params.answers.push({
              'surveyId': this.surveyId,
              'id': this.submitId,
              'questionId': question.id,
              'optionId': question.answer,
              'textValue': question.textValue,
              'answerType': 1
            })
          } else {
            params.answers.push({
              'surveyId': this.surveyId,
              'id': this.submitId,
              'questionId': question.id,
              'optionId': null,
              'subOptionId': null,
              'textValue': null,
              'rateValue': null,
              'answerType': null
            })
          }
        }
        if (question.type === 'multiple') {
          if (question.answers && question.answers.length) {
            question.answers.forEach(answer => {
              const cOption = question.options.find(option => option.id === answer)
              params.answers.push({
                'surveyId': this.surveyId,
                'id': this.submitId,
                'questionId': question.id,
                'optionId': answer,
                'subOptionId': cOption.subAnswer,
                'textValue': cOption.textValue,
                'answerType': 1
              })
            })
          } else {
            params.answers.push({
              'surveyId': this.surveyId,
              'id': this.submitId,
              'questionId': question.id,
              'optionId': null,
              'subOptionId': null,
              'textValue': null,
              'rateValue': null,
              'answerType': null
            })
          }
        }
        if (question.type === 'input') {
          params.answers.push({
            'surveyId': this.surveyId,
            'id': this.submitId,
            'questionId': question.id,
            'textValue': question.answer,
            'answerType': 2
          })
        }
        if (question.type === 'rate') {
          params.answers.push({
            'surveyId': this.surveyId,
            'id': this.submitId,
            'questionId': question.id,
            'rateValue': question.answer,
            'answerType': 3
          })
        }
      })
      try {
        this.loading = true
        const {code, msg} = await surveySubmission(params)
        if (code === 0) {
          if (submitStatus === 0) {
            Toast('保存成功')
          } else {
            Toast('提交成功')
            this.isSubmitSuccess = true
            if (window.history.length > 1) {
              this.$router.back()
            } else {
              this.$router.replace('/home')
            }
          }
        } else {
          Toast(msg)
        }
      } catch (e) {
        throw e
      } finally {
        this.loading = false
      }
    },
    validate() {
      let isValid = true
      this.detailObj.questions.forEach(question => {
        if (question.type === 'single' || question.type === 'input' || question.type === 'rate') {
          if (!question.answer && question.required) {
            this.$set(question, 'error', true)
            isValid = false
          } else {
            delete question.error
          }
          if (question.type === 'single' && question.answer) {
            if (this.getName(question.answer, question.options) === '其他' && !question.textValue) {
              this.$set(question, 'errorText', true)
              isValid = false
            } else {
              delete question.errorText
            }
          }
        }
        if (question.type === 'multiple') {
          if (!question.answers.length && question.required) {
            this.$set(question, 'error', true)
            isValid = false
          } else {
            delete question.error
          }
          if (question.answers.length) {
            question.options.forEach(option => {
              if (option.hasSubOptions && !option.subAnswer && question.answers.includes(option.id)) {
                this.$set(option, 'error', true)
                isValid = false
              } else {
                delete option.error
              }
              if (option.text === '其他' && !option.textValue && question.answers.includes(option.id)) {
                this.$set(option, 'errorText', true)
                isValid = false
              } else {
                delete option.errorText
              }
            })
          } else {
            question.options.forEach(option => {
              delete option.error
              if (option.text === '其他') {
                delete option.errorText
              }
            })
          }
        }
      })
      return isValid
    },
    hasUnsavedAnswers() {
      return this.detailObj.questions.some(question => {
        if (question.type === 'single' || question.type === 'input' || question.type === 'rate') {
          return question.answer
        }
        if (question.type === 'multiple') {
          return question.answers.length > 0 || question.options.some(option => option.subAnswer)
        }
        return false
      })
    },
    beforeRouteLeaveCustom() {
      return new Promise((resolve) => {
        if (this.isNoPermission) {
          resolve(true)
        } else {
          if (this.isSubmitSuccess) {
            resolve(true)
          } else {
            if (this.hasUnsavedAnswers()) {
              Dialog.confirm({
                title: '提示',
                message: '您有未提交的答案，是否要保存并退出？',
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                theme: 'round-button',
                closeOnPopstate: false,
              }).then(async () => {
                // 用户点击确定
                await this.submit(0)
                sessionStorage.setItem('nextTalk', true)
                resolve(true)
              }).catch(() => {
                // 用户点击取消
                resolve(false)
              })
            } else {
              resolve(true)
            }
          }
        }
      })
    }
  }
}

export default withRouteTracking(profile)
</script>

<style scoped lang="less">
.questionnaire-page {
  min-height: 100vh;
  width: 100%;
  padding: 20px;
  background: #fff url("../../assets/images/questionnaire/page-bg.png") no-repeat top left / 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: PingFang SC, PingFang SC;

    .title {
      font-weight: 600;
      font-size: 24px;
      color: #1A1A1A;
      margin-bottom: 16px;
    }

    .desc {
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      margin-bottom: 16px;
      white-space: break-spaces;
      word-break: break-all;
    }
  }

  .question-box {
    flex: 1;

    .question {

      .title {
        display: flex;
        align-items: flex-start;
        font-weight: 600;
        font-family: PingFang SC, PingFang SC;
        line-height: 22px;
        font-size: 15px;
        color: #333333;

        .title-txt {
        }

        .required {
          color: red;
          display: flex;
          align-items: center;
        }
      }

      .question-cont {
        margin: 15px 0;
        padding-left: 12px;

        .error-message {
          color: red;
          margin-top: 5px;
          font-size: 12px;
        }
      }

      .van-checkbox-group {
        .van-checkbox {
          margin-top: 10px;
        }
      }

      .van-cell {
        padding: 5px 16px;
        border-radius: 5px;
        margin-top: 10px;
        border: 1px solid #e9e9e9;
        background: transparent;
      }

      .option-container {
        margin-bottom: 10px;
      }
    }
  }

  .warp-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .submit-btn {
      text-align: center;
      font-size: 17px;
      font-weight: 500;
      width: 130px;
      height: 42px;
      line-height: 42px;
      border-radius: 100px;

      &.btn1 {
        background-color: rgba(0, 0, 0, 0.08);
        color: #7A8494;
        font-size: 16px;
        margin-right: 27px;
      }

      &.btn2 {
        font-size: 16px;
        color: #fff;
        box-sizing: border-box;
        background: #EB1700;
        box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/questionnaire/questionnaire.vue